import script from "./AccOunt.vue?vue&type=script&setup=true&lang=js"
export * from "./AccOunt.vue?vue&type=script&setup=true&lang=js"

import "./AccOunt.vue?vue&type=style&index=0&id=85451c80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85451c80"]])

export default __exports__